// The small menu that opens from a post's ⋮ button (Edit / Pin / Delete).
// Drawn once here so the Home feed and the Profile page look the same.
//
// items: [{ icon, label, onClick, danger }] — a danger item is set apart with
// a thin line and a red tint. Place it inside a `position: relative` wrapper
// next to the ⋮ button; it hangs from that wrapper's top-right corner.
export default function PostMenu({ items }) {
  return (
    <div className="post-menu">
      <style>{css}</style>
      {items.map((item, index) => (
        <div key={item.label}>
          {item.danger && index > 0 && <div className="post-menu-sep" />}
          <button
            type="button"
            className={`post-menu-item${item.danger ? " danger" : ""}`}
            onClick={item.onClick}
          >
            <span className="post-menu-icon">{item.icon}</span>
            {item.label}
          </button>
        </div>
      ))}
    </div>
  );
}

const css = `
  .post-menu {
    position: absolute;
    top: 34px;
    right: 0;
    z-index: 10;
    min-width: 200px;
    padding: 6px;
    background: var(--bg-surface);
    border: 1px solid var(--border-soft);
    border-radius: 14px;
    box-shadow: 0 12px 32px rgba(46, 33, 24, 0.18);
    transform-origin: top right;
    animation: postMenuPop 0.14s ease-out;
  }
  .post-menu-item {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 8px 10px;
    border: none;
    border-radius: 10px;
    background: none;
    color: var(--text-heading);
    font: inherit;
    font-size: 14px;
    font-weight: 600;
    text-align: left;
    cursor: pointer;
  }
  .post-menu-item:hover,
  .post-menu-item:focus-visible {
    background: var(--bg-soft);
    outline: none;
  }
  .post-menu-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: var(--bg-soft);
    font-size: 16px;
    flex-shrink: 0;
  }
  .post-menu-item:hover .post-menu-icon,
  .post-menu-item:focus-visible .post-menu-icon {
    background: var(--bg-surface);
  }
  .post-menu-sep {
    height: 1px;
    margin: 4px 8px;
    background: var(--border-soft);
  }
  .post-menu-item.danger { color: var(--accent-danger); }
  .post-menu-item.danger .post-menu-icon { background: var(--alert-error-bg); }
  .post-menu-item.danger:hover,
  .post-menu-item.danger:focus-visible { background: var(--alert-error-bg); }
  @keyframes postMenuPop {
    from { opacity: 0; transform: scale(0.96) translateY(-4px); }
    to { opacity: 1; transform: none; }
  }
`;
